import styled from '@emotion/styled';
import { tokens, Divider } from '@hotjar/hotsauce';
import { TOPBAR_HEIGHT } from '../../constants';

interface TopBarProps {
  className?: string;
  logo: JSX.Element;
  siteSelector: JSX.Element;
  hideSiteWidgets?: boolean;
  topBarMessage?: JSX.Element;
  samplingWidget?: JSX.Element;
  integrationsLink: JSX.Element;
  inviteMembers: JSX.Element;
  helpMenu: JSX.Element;
  accountMenu: JSX.Element;
  languageSelector: JSX.Element | null;
}

const Container = styled.div`
  box-shadow: inset 0 -1px 0 ${tokens.color.ui_border_light};
  display: flex;
  align-items: center;
  height: ${TOPBAR_HEIGHT}px;
  padding: 0 ${tokens.spacer.x3};
  gap: ${tokens.spacer.x1};
  background-color: ${tokens.color.ui_background};
`;

const FlexNavigation = styled.nav`
  display: flex;
  align-items: center;
  flex-grow: 1;
  gap: ${tokens.spacer.x1};
`;

const StyledDivider = styled(Divider)`
  height: ${tokens.spacer.x3};
  margin: 0;
`;

const CentralContent = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
`;

export const TopBar = ({
  className,
  logo,
  siteSelector,
  topBarMessage,
  hideSiteWidgets,
  samplingWidget,
  integrationsLink,
  inviteMembers,
  helpMenu,
  accountMenu,
  languageSelector,
}: TopBarProps): JSX.Element => (
  <Container className={className}>
    <FlexNavigation aria-label="Current site navigation">
      {logo}
      {!hideSiteWidgets && <StyledDivider orientation="vertical" />}
      <CentralContent>
        {!hideSiteWidgets && siteSelector}
        {topBarMessage}
      </CentralContent>
    </FlexNavigation>
    {languageSelector}
    {!hideSiteWidgets && samplingWidget}
    {integrationsLink}
    {inviteMembers}
    {helpMenu}
    {accountMenu}
  </Container>
);
